import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import messages from 'containers/FastCover/StepOther/messages';
import PageSectionHeader from 'containers/FastCover/components/PageSectionHeader';
import FlexBox from 'components/FlexBox';
import Textbox from 'containers/FastCover/components/Textbox';
import TextArea from 'containers/FastCover/components/TextArea';
import OptionsContainer from 'containers/FastCover/components/OptionsContainer';
import { required } from 'utils/validation/validator';
import { REPORT_TO } from 'containers/FastCover/StepOther/constants';
import {
  ErrorMessage,
  Validate,
} from 'components/Validation';
import { ExpensesClaimed } from '../ExpensesClaimed/index';

export default class ExpenseClaimForm extends React.Component {

  onExpenseClaimedChange = (data) => {
    const { expenseName } = this.props;
    this.props.onExpansesClaimedChange(expenseName, data);
  }

  appendIds = (array) => array.map((item) => {
    let newItem = item; // eslint-disable-line
    if (!item.id) {
      newItem.id = new Date().getTime().toString();
    }
    return newItem;
  });


  renderExpensesClaimed() {
    const { expensesClaimed } = this.props;
    const newExpensesClaimed = this.appendIds(expensesClaimed);
    const { isReadOnly, validationCounter, validatorGroup, expenseType } = this.props;

    return (
      <div>
        <PageSectionHeader>
          {expenseType === 1 && <FormattedMessage {...messages.expensesClaimed} />}
          {expenseType === 2 && <FormattedMessage {...messages.golfExpensesClaimed} />}
          {expenseType === 3 && <FormattedMessage {...messages.bicycleExpensesClaimed} /> }
          {expenseType === 4 && <FormattedMessage {...messages.expensesClaimedOther} /> }
        </PageSectionHeader>
        <ExpensesClaimed
          data={newExpensesClaimed}
          onChange={this.onExpenseClaimedChange}
          disabled={isReadOnly}
          validatorGroup={validatorGroup}
          validationCounter={validationCounter}
          expenseType={expenseType}
        />
      </div>
    );
  }

  renderExplainForm = () => {
    const {
      additional,
      // claimingFor,
      whoDidYouReportThisTo,
      otherDescription,
      reportReferenceNumber,
    } = this.props.claimDetail;
    const { isReadOnly, onChange, exenseDetailName, isSummary } = this.props;

    return (
      <div>
        <div className="row">
          <div className="form-group col-12">
            <PageSectionHeader>
              <FormattedMessage {...messages.anyThingAdditionalToAdd} />
            </PageSectionHeader>
            <TextArea
              disabled={isReadOnly}
              name="additional"
              type="text"
              onChange={onChange(`${exenseDetailName}.additional`)}
              value={additional}
              isSummary={isSummary}
            />
          </div>
        </div>

        <div className="row">
          <div className="form-group col-sm-6">
            <Validate
              name="whoDidYouReportThisTo"
              validators={[required]}
              group={this.props.validatorGroup}
              addValidatorToGroup={this.props.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.props.validatorGroup.validChangeInGroup}
              validationCounter={this.props.validationCounter}
              validatorLeaveGroup={this.props.validatorGroup.removeValidatorToGroup}
              defaultValue={whoDidYouReportThisTo}
              fieldName={messages.whoDidYouReportThisTo}
            >
              <FlexBox justifyContent="space-between">
                <FlexBox direction="column">
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      checked={whoDidYouReportThisTo === REPORT_TO.POLICE}
                      onChange={onChange(`${exenseDetailName}.whoDidYouReportThisTo`)}
                      value={REPORT_TO.POLICE}
                    />
                    <FormattedMessage {...messages.police} />
                  </OptionsContainer>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      checked={whoDidYouReportThisTo === REPORT_TO.HOTEL_MANAGEMENT}
                      onChange={onChange(`${exenseDetailName}.whoDidYouReportThisTo`)}
                      value={REPORT_TO.HOTEL_MANAGEMENT}
                    />
                    <FormattedMessage {...messages.hotelManagement} />
                  </OptionsContainer>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      checked={whoDidYouReportThisTo === REPORT_TO.CRUISE_SHIP}
                      onChange={onChange(`${exenseDetailName}.whoDidYouReportThisTo`)}
                      value={REPORT_TO.CRUISE_SHIP}
                    />
                    <FormattedMessage {...messages.cruiseShip} />
                  </OptionsContainer>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      checked={whoDidYouReportThisTo === REPORT_TO.AIRLINE}
                      onChange={onChange(`${exenseDetailName}.whoDidYouReportThisTo`)}
                      value={REPORT_TO.AIRLINE}
                    />
                    <FormattedMessage {...messages.airline} />
                  </OptionsContainer>
                </FlexBox>
                <FlexBox direction="column">
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      checked={whoDidYouReportThisTo === REPORT_TO.TOUR_GUIDE}
                      onChange={onChange(`${exenseDetailName}.whoDidYouReportThisTo`)}
                      value={REPORT_TO.TOUR_GUIDE}
                    />
                    <FormattedMessage {...messages.tourGuide} />
                  </OptionsContainer>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      checked={whoDidYouReportThisTo === REPORT_TO.OTHER}
                      onChange={onChange(`${exenseDetailName}.whoDidYouReportThisTo`)}
                      value={REPORT_TO.OTHER}
                    />
                    <FormattedMessage {...messages.other} />
                  </OptionsContainer>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      checked={whoDidYouReportThisTo === REPORT_TO.NOT_REPORT}
                      onChange={onChange(`${exenseDetailName}.whoDidYouReportThisTo`)}
                      value={REPORT_TO.NOT_REPORT}
                    />
                    <FormattedMessage {...messages.notReported} />
                  </OptionsContainer>
                </FlexBox>
              </FlexBox>
              <ErrorMessage for="required">
                <FormattedMessage {...messages.isRequired} values={messages.whoDidYouReportThisTo} />
              </ErrorMessage>
            </Validate>
          </div>
          <div className="form-group col-sm-6">
            <PageSectionHeader>
              <FormattedMessage {...messages.otherDescription} />
            </PageSectionHeader>
            <TextArea
              disabled={isReadOnly}
              name="otherDescription"
              type="text"
              onChange={onChange(`${exenseDetailName}.otherDescription`)}
              value={otherDescription}
              isSummary={isSummary}
            />
          </div>
        </div>

        <div className="row">
          <div className="form-group col-sm-6">
            <PageSectionHeader>
              <FormattedMessage {...messages.reportReferenceNumber} />
            </PageSectionHeader>
            <Textbox
              disabled={isReadOnly}
              name="reportReferenceNumber"
              type="text"
              onChange={onChange(`${exenseDetailName}.reportReferenceNumber`)}
              value={reportReferenceNumber}
            />

          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div>
        {this.renderExplainForm()}
        {this.renderExpensesClaimed()}
      </div>
    );
  }
}

ExpenseClaimForm.propTypes = {
  claimDetail: PropTypes.object,
  validatorGroup: PropTypes.object,
  onChange: PropTypes.func,
  validationCounter: PropTypes.number,
  onExpansesClaimedChange: PropTypes.func,
  expensesClaimed: PropTypes.array,
  expenseName: PropTypes.string,
  exenseDetailName: PropTypes.string,
  isReadOnly: PropTypes.bool,
  expenseType: PropTypes.number,
  isSummary: PropTypes.bool,
};

ExpenseClaimForm.defaultProps = {
  expenseType: 1,
};




// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.Starr.StepOther/components/OtherExpenseClaimForm/index.js